import useMoney from '../../../../hooks/useMoney';
import { useTranslation } from '../../../translation/TranslationContext';
import { VizValueFormat } from '../viz.types';
import {
  formatVizPointLabel,
  formatVizValue,
  formatVizValueCompact,
  getNumberFormatter,
} from '../viz.utils';

const SHARE_OPTIONS: Intl.NumberFormatOptions = { style: 'percent', maximumFractionDigits: 0 };

export const useVizFormatters = (format?: VizValueFormat) => {
  const { formatMoney } = useMoney();
  const { locale } = useTranslation();

  return {
    locale,
    formatCompact: (value: number) => formatVizValueCompact({ value, format, formatMoney, locale }),
    formatFull: (value: number) => formatVizValue({ value, format, formatMoney, locale }),
    formatShare: (value: number) => getNumberFormatter(locale, SHARE_OPTIONS).format(value),
    formatPointLabel: (label: string) => formatVizPointLabel({ label, locale }),
  };
};
